<template>
  <div>
    <!-- Add new -->
    <b-row align-h="end" class="mx-0 mb-3">
      <Button variant="orange" @click="createSubmital">
        <font-awesome-icon :icon="['fas', 'plus-circle']" fixed-width />
        <span class="pl-1">Control de Acceso</span>
      </Button>
    </b-row>

    <!-- mobile -->
    <b-row class="d-xl-none">
      <b-col>
        <template v-if="submitals.length">
          <ProjectShowSubmitalCard
            v-for="submital in submitals"
            :submital="submital"
            :is-authorized="isAuthorized"
            :key="submital.id"
            @copy-submital="copySubmital"
          />
        </template>
        <div v-else class="text-center py-3">
          <p class="fs-14 mb-1">No hay submitals registrados</p>
        </div>
      </b-col>
    </b-row>

    <b-row class="d-none d-xl-block">
      <b-col>
        <b-table
          :items="submitals"
          :fields="fields"
          tbody-tr-class="access-list-row"
          hover
          show-empty
          class="border-bottom fs-14"
        >
          <template #empty>
            <div class="text-center py-3">
              <p class="fs-14 mb-1">No hay submitals registrados</p>
            </div>
          </template>

          <template v-slot:cell(submital_no)="data">
            <p v-if="data.value" class="mb-0">
              <font-awesome-icon v-if="submitalLocked(data.item)" :icon="['fas', 'lock-alt']" fixed-width />
              <span>{{ data.value }}</span>
            </p>
            <span v-else>-</span>
          </template>

          <template v-slot:cell(title)="data">
            <div v-if="isAuthorized && !submitalLocked(data.item)">
              <b-input
                v-if="editingTitle && data.item.id == selectedSubmital.id"
                v-model="selectedSubmitalForm.title"
                size="sm"
                autofocus
                @blur="updateSubmital"
                @keyup.enter="updateSubmital"
              />
              <div v-else>
                <b-link v-if="data.value" class="edit-link" @click="editSubmital(data.item, 'editingTitle')" @mouseover="hoverSubmital(data.item.id, 'hoveringTitle')" @mouseleave="unhoverSubmital">
                  {{ data.value }}<font-awesome-icon v-show="hoveringTitle && data.item.id == hoveredSubmitalId" :icon="['fas', 'edit']" fixed-width class="text-black-50" />
                </b-link>
                <b-link v-else class="font-italic edit-link text-muted" @click="editSubmital(data.item, 'editingTitle')" @mouseover="hoverSubmital(data.item.id, 'hoveringTitle')" @mouseleave="unhoverSubmital">
                  (Sin Nombre)<font-awesome-icon v-show="hoveringTitle && data.item.id == hoveredSubmitalId" :icon="['fas', 'edit']" fixed-width class="text-black-50" />
                </b-link>
              </div>
            </div>
            <div v-else>
              <span v-if="data.value">{{ data.value }}</span>
              <span v-else class="font-italic text-muted">(Sin Nombre)</span>
            </div>
          </template>

          <!-- Quantity -->
          <template v-slot:cell(quantity)="data">
            <div v-if="isAuthorized && !submitalLocked(data.item)">
              <div v-if="editingQuantity && data.item.id == selectedSubmital.id">
                <b-input
                  v-model.number="selectedSubmitalForm.quantity"
                  size="sm"
                  autofocus
                  min="1"
                  style="width: 50px"
                  v-on="selectedSubmitalForm.quantity && selectedSubmitalForm.quantity > 0 ? { blur: () => updateSubmital() } : { blur: () => cancelEditing() }"
                />
              </div>
              <b-link v-else class="edit-link" @click="editSubmital(data.item, 'editingQuantity')" @mouseover="hoverSubmital(data.item.id, 'hoveringQuantity')" @mouseleave="unhoverSubmital">
                {{ data.value }}<font-awesome-icon v-show="hoveringQuantity && data.item.id == hoveredSubmitalId" :icon="['fas', 'edit']" fixed-width class="text-black-50" />
              </b-link>
            </div>
            <span v-else>{{ data.value }}</span>
          </template>

          <!-- related_configurable -->
          <template v-slot:cell(related_configurable)="data">
            <span v-if="data.item.related_configurable">{{ data.item.related_configurable.submital_no || data.item.related_configurable.acceso_id }}</span>
            <span v-else>-</span>
          </template>

          <!-- control_type -->
          <template v-slot:cell(control_type)="data">
            <span v-if="data.item.configurable && data.item.configurable.access_control_type">{{ data.item.configurable.access_control_type.name }}</span>
            <span v-else>-</span>
          </template>

          <!-- Status -->
          <template v-slot:cell(status)="data">
            <b-row v-if="isAuthorized" align-h="around">
              <div v-if="data.item.progress == 100">
                <font-awesome-icon :icon="['fas', 'check-square']" size="lg" fixed-width class="text-success" />
              </div>
              <b-link v-if="data.item.alarm_data && Object.keys(data.item.alarm_data).length > 0" style="color: inherit" @click="openAlarmsModal(data.item)">
                <font-awesome-icon :icon="['fas', 'exclamation-circle']" size="lg" fixed-width class="text-danger" />
              </b-link>
              <b-link v-if="data.item.warnings.length > 0" style="color: inherit" @click="openAlarmsModal(data.item)">
                <font-awesome-icon :icon="['fas', 'exclamation-triangle']" size="lg" fixed-width class="text-warning" />
              </b-link>
            </b-row>
            <div v-else>
              <font-awesome-icon title="No autorizado" :icon="['fas', 'ban']" size="lg" fixed-width class="text-danger" />
            </div>
          </template>

          <!-- Progress -->
          <template v-slot:cell(progress)="data">{{ data.value }}%</template>

          <!-- Actions -->
          <template v-slot:cell(actions)="data">
            <b-row v-if="isAuthorized" align-h="around" align-v="center">
              <Button size="sm" title="Copiar" style="height: 28px" @click="copySubmital(data.item, false)">
                <font-awesome-icon :icon="['far', 'copy']" size="lg" fixed-width />
              </Button>
              <Button size="sm" variant="blue" @click="goToSubmital(data.item)">
                Config
              </Button>
            </b-row>
          </template>
        </b-table>
      </b-col>
    </b-row>

    <!-- Transfer Project Modal -->
    <Modal
      v-if="alarmsModalShow"
      contentWidth="600px"
      :required=true
      @close="alarmsModalShow = false"
    >
      <template #header>
        <p class="fs-20 font-weight-bold ml-1 mb-0" style="line-height: 0.675rem; color: #163D7D;">
          Alarmas y avisos de submital {{ selectedSubmital.submital_no }}
        </p>
      </template>
      <template #body>
      <b-row align-h="center">
        <b-col>
          <b-container v-if="selectedSubmital.id" class="px-3">
            <div v-for="(stepData, stepName) in selectedSubmital.alarm_data" :key="stepName">
              <b-row v-for="(alarmObj, index) in stepData.alarms" :key="index">
                <p class="text-danger mb-1">
                  {{ Object.values(alarmObj)[0] }}
                </p>
              </b-row>
            </div>
            <b-row v-if="selectedSubmital.warnings.length > 0">
              <p v-for="warning in selectedSubmital.warnings" :key="warning" class="text-warning mb-1">
                <font-awesome-icon :icon="['far', 'ban']" fixed-width />
                {{ warning }}
              </p>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
      </template>
      <template #footer>
        <Button variant="green" :disabled="!transfereeId" @click="transfer">
          Transferir
        </Button>
      </template>
    </Modal>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import ProjectShowSubmitalCard from './ProjectShowSubmitalCard'
import Button from '../../shared/Button'
import Modal from '../../shared/Modal'


import ControlAccesoImage from 'images/access_control.webp'

export default {
  name: 'ProjectAccessControlList',
  props: {
    project: Object,
    submitalData: Object,
    submitalList: Array,
  },
  components: {
    ProjectShowSubmitalCard,
    Button,
    Modal
  },
  data () {
    return {
      processing: false,
      fields: [
        { key: 'submital_no', label: 'ID', thClass: 'top-borderless', thStyle: { width: '90px' } },
        { key: 'quantity', label: 'Cant.', tdClass: 'text-center', thClass: 'top-borderless text-center', thStyle: { width: '95px' } },
        { key: 'title', label: 'Nombre', thClass: 'top-borderless', thStyle: { width: '300px' }},
        { key: 'control_type', label: 'Actuador', tdClass: 'text-left', thClass: 'top-borderless' },
        { key: 'related_configurable', label: 'Submital', tdClass: 'text-left', thClass: 'top-borderless' },
        { key: 'status', label: '', tdClass: 'text-center', thClass: 'top-borderless' },
        { key: 'progress', label: 'Progreso', tdClass: 'text-center', thClass: 'top-borderless text-center' },
        { key: 'actions', label: '', thClass: 'top-borderless', thStyle: { width: '120px' } }
      ],
      selectedSubmital: {},
      selectedSubmitalForm: {
        title: null,
        quantity: null
      },
      hoveredSubmitalId: null,
      editingTitle: false,
      editingQuantity: false,
      hoveringTitle: false,
      hoveringQuantity: false,
      alarmsModalShow: false
    }
  },
  computed: {
    ...mapGetters (['isSupervisor']),
    currentUser () { return this.$store.state.currentUser },
    isAuthorized () { return (this.isSupervisor || this.currentUser.id === this.project.user_id) ? true : false },
    submitals () {
      return this.submitalList.map(id => this.submitalData[id]).sort((a,b) => new Date(b.created_at) - new Date(a.created_at))
    },
    controlAccesoImg () { return ControlAccesoImage }
  },
  methods: {
    goToSubmital (submital) {
      this.$router.push(`/app/prod/submitals/${submital.id}`)
    },
    createSubmital () {
      if (window.confirm('¿Crear submital de Control de Acceso?')) {
        if (this.processing) { return }
        this.processing = true
        this.$http.post(`/api/production/submitals`, {
            configurable_type: 'ControlAcceso',
            submital: {
              client_id: this.project.client.id,
              project_id: this.project.id,
              salesperson_id: this.project.user_id
            }
          })
          .then((res) => {
            // console.log('creating Submital')
            // console.log(res)
            this.$emit('submital-created', res.data)
          })
          .catch(e => {
            // console.log(e)
            this.$emit('display-alert', {
              message: 'No funcionó',
              variant: 'danger',
              time: 4000
            })
          })
          .finally(this.processing = false)
      }
    },
    copySubmital (submital, isMobile) {
      if (window.confirm(`¿Está seguro de que quiere copiar el submital ${submital.submital_no}?`)) {
        if (this.processing) { return }
        this.processing = true
        this.$http.post(`/api/production/submitals/${submital.id}/copy`)
          .then(response => {
            // console.log(response)
            this.$emit('submital-created', response.data)
            if (isMobile) {
              window.scrollTo({
                top: 250,
                left: 0,
                behavior: 'smooth'
              })
            }
          })
          .catch(error => {
            // console.log(error)
          })
          .finally(this.processing = false)
      }
    },
    openAlarmsModal (submital) {
      this.selectedSubmital = submital
      this.alarmsModalShow = true
    },
    editSubmital (submital, property) {
      this.selectedSubmital = submital
      this.selectedSubmitalForm.title = this.selectedSubmital.title
      this.selectedSubmitalForm.quantity = this.selectedSubmital.quantity
      this[property] = true
    },
    cancelEditing () {
      this.editingTitle = false
      this.editingQuantity = false
      this.hoveredSubmitalId = null
      this.hoveringTitle = false
      this.hoveringQuantity = false
    },
    hoverSubmital (submitalId, property) {
      this.hoveredSubmitalId = submitalId
      this[property] = true
    },
    unhoverSubmital () {
      this.hoveredSubmitalId = null
      this.hoveringTitle = false
      this.hoveringQuantity = false
    },
    updateSubmital () {
      if (this.processing) { return }
      this.processing = true;
      this.$http.patch(`/api/production/submitals/${this.selectedSubmital.id}`, {
          submital: this.selectedSubmitalForm
        })
        .then((res) => {
          this.$emit('submital-updated', res.data)
          this.cancelEditing()
        })
        .catch((e) => {
          this.$emit('display-alert', {
            message: 'No funcionó',
            variant: 'danger',
            time: 4000
          })
        })
        .finally(this.processing = false)
    },
    submitalLocked (submital) {
      return submital.locked_at != null
    }
  }
}
</script>
